'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$() {
  this.aI2 = null;
  this.aIj = null;
  this.aI5 = null;
  this.aI6 = false;
  this.aIb = null;
  this.aIc = false;
  this.aIh = null;
  this.aIi = false;
  this.aI3 = null;
  this.aI4 = false;
  this.aIf = null;
  this.aIg = false;
  this.aId = null;
  this.aIe = false;
  this.aI7 = null;
  this.aI8 = false;
  this.aI9 = null;
  this.aIa = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ = this;
  this.aI2 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$();
  this.aIj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aI2;
});
$p.eO = (function() {
  return this.aIj;
});
$p.bW = (function() {
  if ((!this.aI6)) {
    this.aI5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aI6 = true;
  }
  return this.aI5;
});
$p.b9 = (function() {
  if ((!this.aIc)) {
    this.aIb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aIc = true;
  }
  return this.aIb;
});
$p.b3 = (function() {
  if ((!this.aIi)) {
    this.aIh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aIi = true;
  }
  return this.aIh;
});
$p.aG = (function() {
  if ((!this.aI4)) {
    this.aI3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aI4 = true;
  }
  return this.aI3;
});
$p.az = (function() {
  if ((!this.aIg)) {
    this.aIf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aIg = true;
  }
  return this.aIf;
});
$p.aY = (function() {
  if ((!this.aIe)) {
    this.aId = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aIe = true;
  }
  return this.aId;
});
$p.Jd = (function() {
  if ((!this.aI8)) {
    this.aI7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Container Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aI8 = true;
  }
  return this.aI7;
});
$p.bsh = (function() {
  if ((!this.aIa)) {
    this.aI9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aIa = true;
  }
  return this.aI9;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$, "app.data.data_point_types$package$ContainerNumberForm$", ({
  FB: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$() {
  this.aI0 = null;
  this.aI1 = false;
  this.aHY = null;
  this.aHZ = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aI1)) {
    this.aI0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aI1 = true;
  }
  return this.aI0;
});
$p.brV = (function() {
  if ((!this.aHZ)) {
    this.aHY = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumberForm$().Jd();
    this.aHZ = true;
  }
  return this.aHY;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$, "app.data.data_point_types$package$ContainerNumber$", ({
  FA: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ContainerNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Container-Number$.js.map
